export const auctionsEndpoints = {
  getRequestAuction: { method: 'get', path: '/request-auction/{requestId}' },
  listAuctionLots: { method: 'get', path: '/{auctionId}/lots' },
  createAuctionLots: { method: 'post', path: '/{auctionId}/lots' },
  getAuctionLot: { method: 'get', path: '/{auctionId}/lots/{lotId}' },
  updateAuctionLot: { method: 'post', path: '/{auctionId}/lots/{lotId}' },
  deleteAuctionLot: { method: 'post', path: '/{auctionId}/lots/{lotId}/delete' },
  getAuction: { method: 'get', path: '/{auctionId}' },
  launchAuction: { method: 'post', path: '/{auctionId}/launch' },
  updateAuctionSettings: { method: 'post', path: '/{auctionId}/settings' },
  updateAuctionSupplierInstructions: { method: 'post', path: '/{auctionId}/supplier-instructions' },
  updateAuctionState: { method: 'post', path: '/{auctionId}/update-state' },
  listAuctionOwners: { method: 'get', path: '/{auctionId}/owners' },
  updateAuctionOwners: { method: 'post', path: '/{auctionId}/owners' },
  listAuctionSuppliers: { method: 'get', path: '/{auctionId}/suppliers' },
  addAuctionSuppliers: { method: 'post', path: '/{auctionId}/suppliers' },
  rejectAuctionSupplier: { method: 'post', path: '/{auctionId}/suppliers/{auctionSupplierId}/reject' },
  resendAuctionSupplierInvitation: { method: 'post', path: '/{auctionId}/suppliers/{auctionSupplierId}/resend-invitation' },
  deleteAuctionSupplier: { method: 'post', path: '/{auctionId}/suppliers/{auctionSupplierId}/delete' },
  getSupplierAuctionDetail: { method: 'get', path: '/supplier-portal/auctions/{auctionId}' },
  placeSupplierBid: { method: 'post', path: '/supplier-portal/auctions/{auctionId}/lots/{lotId}/bids' },
  withdrawAuctionSupplier: { method: 'post', path: '/supplier-portal/auctions/{auctionId}/withdraw' },
} as const
